<template>
    <div>
        <b-modal
            ref="modalInfoExtrato"
            size="md"
            scrollable
            id="modal-info-extrato"
            title="Informações sobre Extrato Bancário">

            <p style="text-align:justify">
                Veja como o franqueado pode autorizar o acesso ao extrato da conta bancária.
                <br><br>

                <el-button type="primary" style="text-align:center; margin:0 auto; display:block;">
                  <a href="https://f360.zendesk.com/hc/pt-br/articles/12998722188183" target="_blank" rel="noopener" style="color:#fff">Tutorial</a>
                </el-button>

                <br><br>

                Embora a conta bancária esteja associada a um CNPJ específico, o franqueado tem a possibilidade de conciliar transações financeiras em mais de uma loja.<br><br>

                Exemplo: um franqueado pode pagar uma guia do Simples Nacional usando uma conta bancária e ratear essa despesa entre várias lojas.
                
            </p>
                <template #modal-footer="{ hide }">
                    <div class="float-right">
                        <el-button size="small" @click="hide()">Fechar</el-button>
                    </div>
                </template>
            </b-modal>
    </div>
</template>
<script>
export default {
    name: 'ModalExportarExtratoBancario'
};
</script>
